import * as React from "react"
import { Button } from "react-bootstrap"

interface ImportConversionRuleProps {
  children?: React.ReactNode
  className?: string
}

export const ImportConversionRule = (props: ImportConversionRuleProps) => {
  const fileInput = React.useRef(null)

  const onButtonClick = () => {
    ;(fileInput.current as any)?.click()
  }

  const onSelectFile = async (e: any) => {
    const inputFile = e.target.files[0]
    e.target.value = null // In order to reset the input file field
    console.log("Input file: ", inputFile)
  }

  return (
    <>
      <input
        type="file"
        accept="application/xml,.xml"
        ref={fileInput}
        style={{ display: "none" }}
        onChange={onSelectFile}
      />
      <Button variant="secondary" size="sm" onClick={onButtonClick} className={props.className}>
        {props.children}
      </Button>
    </>
  )
}
